/**
 * Core
 */
import { React, useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'

/**
 * Components
 */
import Footer from '../components/footer'


const JudgeProfile = () => {

    const { judgeName } = useParams();

    const [judges, setJudges] = useState([]);

     useEffect(() => {
                fetch('https://api.awintern.com/api/v1/judge_certifications/programs/65')
                .then((res) => {
                    return res.json(); 
                })
                .then((data) => {
                   setJudges(data);
                })
                .catch((error) => {
                    console.error('Error:', error); 
                });
            }, [])    
            
    return (
        <>
        <section className='bg-gray-100 text-ai-gray-900 pt-16'>
    
                
        </section>

        <section className='pb-0 border-t border-t-ai-gray-800'>
            <Footer />
        </section>
        </>
    )
}

export default JudgeProfile